var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.238,
    height: 33.651,
    viewBox: "0 0 25.238 33.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6666",
    "data-name": "Path 6666",
    d: "M88.3,248.565H69.371a3.155,3.155,0,0,0-3.155,3.155v1.051H91.454V251.72A3.155,3.155,0,0,0,88.3,248.565Zm-5.51-2.1.464,3.319H74.417l.464-3.319h7.908m.253-2.1H74.628a1.873,1.873,0,0,0-1.8,1.563l-.615,4.4a1.337,1.337,0,0,0,1.359,1.562H84.093a1.337,1.337,0,0,0,1.359-1.562l-.615-4.4a1.873,1.873,0,0,0-1.8-1.563Zm5.783,10.515H68.845a1.891,1.891,0,0,0-1.913,2.1l1.722,18.946a2.354,2.354,0,0,0,2.294,2.094H86.722a2.354,2.354,0,0,0,2.294-2.094l1.722-18.946A1.891,1.891,0,0,0,88.825,254.874ZM74.628,273.8H71.474l-1.052-14.722h4.206Zm6.31,0H76.732V259.081h4.206Zm5.258,0H83.042V259.081h4.206Z",
    transform: "translate(-66.216 -244.359)",
    fill: "#d1d1d1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8f92062308b823f312479c58cf9529b1.svg";
export { ForwardRef as ReactComponent };